import * as React from 'react'
import Widgets from "src/components/widgets";

import ArchivalCollection from './archivalColleciton';
import StaffList from './staffList';
import UserExperienceReportList from './userExperienceReportList';
import StudySpaceList from './studySpacesList';
import UpcomingEvents from './upcomingEvents';
import OmniSearch from './omniSearch';
import QualityAssuranceReportList from './qualityAssuranceReportList';
import AssessmentPlanList from './assessmentPlanList';
import ServiceHours from './serviceHours';
import LinksItems from './linksItems';
import DLCList from './DLCList';

/**
 * UGLibWidgets is a drop-in replacement for the CCS <Widgets> component. It wraps the <Widgets> component, 
 * selectively choosing to render a UGLib custom paragraph component or an upstream CCS component for each widget.
 * 
 * This allows us to define our own custom paragraph types without hacking up their Widgets component, and to mix our custom paragraphs with theirs in content. 
 * If CCS adds more paragraph types in the future those should seamlessly integrate with our own. 
 * 
 * To determine how to render each Widget, it searches for custom component types in the __typename attribute of the pageData element.
 * In most cases, it will defer rendering to the CCS widget component. For library custom widgets (as defined in the uglib_types array) it will render our custom component instead. 
 * 
 * NOTE: If you want to add custom paragraph types, you must add them to the uglib_types array and provide a mapping to your custom component.
 * 
 * NOTE: You'll also want to:
 * - Add custom paragraph types to gatsby-node.js "union widgetParagraphUnion"
 * - Add your desired paragraph fields to the page query in {NodePage.path__alias}.js, under nodes.relationships.field_widgets (eg ... on paragraph__uglib_custom_type).
 * 
 * @param {} param0 
 * @returns An array of React.Component objects
 */

function UGLibWidgets ({pageData}) {

    if(pageData === null) {
        return;
    }
    
    // Add custom paragraph types to this array.
    const uglib_types = [
        'paragraph__archival_collection',
        'paragraph__staff_list',
        'paragraph__user_experience_reports',
        'paragraph__study_spaces_list',
        'paragraph__upcoming_events_workshops',
        'paragraph__omni_search',
        'paragraph__quality_assurance_reports',
        'paragraph__assessment_plan_list',
        'paragraph__service_hours',
        'paragraph__link_item',
        'paragraph__dlc_list'
    ]

    let results = [];
    results = pageData.map((data) => {
        let widget = {};
        if(uglib_types.includes(data.__typename)) {
            widget = uglib_component_mapping(data);
        }
        else {
            widget = <Widgets pageData={[data]} />;
        }
        
        return widget;
    })

    return results;
}

/**
 * Add custom paragraph mappings to this function.
 * @param {*} data 
 * @returns React.Component
 */
function uglib_component_mapping(data) {

    if(data.__typename === 'paragraph__archival_collection') {
        return <ArchivalCollection category={data.field_archives_category} other_category={data.field_archives_other_category} />;
    }

    if(data.__typename === 'paragraph__staff_list') {
        return <StaffList team={data.field_team} subteam={data.field_subteam}/>;
    }

    if(data.__typename === 'paragraph__user_experience_reports') {
        
        return <UserExperienceReportList />;
    }

    if(data.__typename === 'paragraph__study_spaces_list') {
        return <StudySpaceList />;
    }

    if(data.__typename === 'paragraph__upcoming_events_workshops') {
        let body = null;
        if(data.field_p_upcoming_event_body) {
            body = data.field_p_upcoming_event_body.processed;
        }

        return <UpcomingEvents title="Upcoming workshops" category={data.field_p_upcoming_event_category} limit={data.field_p_upcoming_event_limit}><div dangerouslySetInnerHTML={{__html: body}} /></UpcomingEvents>;
    }

    if(data.__typename === 'paragraph__omni_search') {
        return <OmniSearch />;
    }

    if(data.__typename === 'paragraph__quality_assurance_reports') {
        return <QualityAssuranceReportList />;
    }

    if(data.__typename === 'paragraph__assessment_plan_list') {
        return <AssessmentPlanList />;
    }

    if(data.__typename === 'paragraph__service_hours') {
        return <ServiceHours />;
    }

    if(data.__typename === 'paragraph__link_item') {
        return <LinksItems />;
    }

    if(data.__typename === 'paragraph__dlc_list') {
        const category = data.relationships.field_dlc_list_category !== null ? data.relationships.field_dlc_list_category.name : "";
        const search = data.field_dlc_list_search_text !== null ? data.field_dlc_list_search_text : "";
        const limit = data.field_dlc_list_limit;

        return <DLCList tag={ category } search={ search } limit={ limit } randomize={ true } />;
    }

    console.warn("Missing UGLib Paragraph Mapping");
    return null
}

export default UGLibWidgets;